import { render, staticRenderFns } from "./SalesPitch.vue?vue&type=template&id=4bf4b33a&scoped=true&"
import script from "./SalesPitch.vue?vue&type=script&lang=js&"
export * from "./SalesPitch.vue?vue&type=script&lang=js&"
import style0 from "./SalesPitch.vue?vue&type=style&index=0&id=4bf4b33a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf4b33a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf4b33a')) {
      api.createRecord('4bf4b33a', component.options)
    } else {
      api.reload('4bf4b33a', component.options)
    }
    module.hot.accept("./SalesPitch.vue?vue&type=template&id=4bf4b33a&scoped=true&", function () {
      api.rerender('4bf4b33a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/option/SalesPitch.vue"
export default component.exports